import React from "react";
import PageHeader from "../components/page-header";
import EbookBox from "../components/ebook-box";

const ResourcesEbooks = () => {
  const caseStudies = [...Array(5).keys()];
  return (
    <div className="page-inside page-ebooks">
      <PageHeader page="ebooks" />
      <div className="container">
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-9">
            <ul className="list-unstyled casestudies-box row d-flex justify-content-center">
              {caseStudies.map((x, key) => (
                <li key={key} className="col-lg-4 mb-5">
                  <EbookBox id={"EB" + (key + 1)} />
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesEbooks;
